import { useState, useEffect } from 'react';
import "./ExploreTheProcess.css";

function ExploreTheProcess() {
    const [viewport, setViewport] = useState(0);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        const updateViewport = () => {
            setViewport(document.documentElement.clientWidth);
        };

        // Set initial viewport size
        updateViewport();

        // Listen to resize
        window.addEventListener('resize', updateViewport);

        // Delay rendering iframe slightly to prevent flicker
        const timeout = setTimeout(() => {
            setIsClient(true);
        }, 100); // 100ms is usually enough

        // Cleanup on unmount
        return () => {
            window.removeEventListener('resize', updateViewport);
            clearTimeout(timeout);
        };
    }, []);

    const containerClasses = `section explore-container anchor-1 ${viewport >= 992 ? "desktop" : "mobile"}`;
    const videoClasses = `video-box container-fluid ${viewport >= 992 ? "desktop" : "mobile"}`;
    const headingClasses = `header ${viewport >= 992 ? "desktop" : "mobile"}`;

    return (
        <div className={containerClasses} id="explore">
            <h2 className={headingClasses}>Explore the Process</h2>
            <div className={videoClasses}>
                {isClient && viewport > 0 ? (
                    <iframe
                        className="responsive-iframe"
                        src="https://www.youtube-nocookie.com/embed/EJAH4NK7KGs?autoplay=1&mute=1&loop=1&playlist=EJAH4NK7KGs&modestbranding=1&controls=1&rel=0"
                        allow="autoplay; fullscreen"
                    ></iframe>
                ) : (
                    <p>Loading video...</p>
                )}
            </div>
        </div>
    );
}

export default ExploreTheProcess;
